













































































import { changeAbtestScene } from "@/services/api";
import { Loading } from "element-ui";
import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class ABTestEditTable extends Vue {
  @Prop()
  tableDetail?:any;

  tableData:any[] = [];

  type = 0;

  mounted() {
    console.log('mounted');
    // this.tableData = JSON.parse(JSON.stringify(this.tableDetail?.items || []));
    this.tableData = this.tableDetail?.abFormList || [];
    this.type = this.tableDetail.sceneType || 0;
  }

  changeType(scene: number) {
    this.type = scene;
    if (scene != this.tableDetail.sceneType) {
      // const fullLoading = Loading.service({fullscreen:true});
      changeAbtestScene({
        id: this.tableDetail.id,
        sceneType: scene,
      }).then((res:any) => {
        // fullLoading.close();
        this.$emit('changeDetail');
      }).catch(() => {
        // fullLoading.close();
      });
    }
  }

  changeEditLiuliang(scope:any, index: number, v:boolean) {
    if (scope.row.flowRate >= 100) {
      scope.row.flowRate = 99;
    } else if (scope.row.flowRate <= 0) {
      scope.row.flowRate = 1;
    } else {
      scope.row.flowRate = parseInt(scope.row.flowRate);
    }
    // scope.row.editliuliang = v;
    // this.tableData[index].editliuliang = v;
    this.tableData[index].flowRate = scope.row.flowRate;

    // 两个的情况下计算
    if (this.tableData.length > 1) {
      this.tableData[this.tableData.length - 1 - index].flowRate = 100 - scope.row.flowRate;
    }
    // Vue.set(this.tableData[index], 'editliuliang', true);
    setTimeout(() => {
      this.$emit('saveDraftNoTip');
    }, 100);
  }

  // isEditLiuliang(scope:any) {
  //   return scope.row.editliuliang == true;
  // }

  editItem(scope:any) {
    if (scope.row.type == 1) {
      this.$router.push(`/wheel_of_fortune/setting/${scope.row.formId}?abtest=true&edit=true&idx=${scope.$index}&abtestid=${this.tableDetail.id}`)
    }else if(scope.row.type == 2){
      this.$router.push(`/wheel_of_fortune/pop/${scope.row.formId}?abtest=true&edit=true&idx=${scope.$index}&abtestid=${this.tableDetail.id}`)
    }
  }

  delItem(index:number) {
    // delete this.tableData[index];
    // this.tableData.splice(index, 1);
    this.$emit('deleteItem', index);
  }
}
